import { useEffect } from 'react';
import {
  PartialEventWithRequiredAction,
  useSendAnalytics,
} from 'src/components/AnalyticsProvider/useSendAnalytics';

export interface UseDownloadCompleteModalAnalytics {
  sendAnalyticsBefore: (
    cb: () => void,
    eventData: PartialEventWithRequiredAction
  ) => void;
}

export const useDownloadCompleteModalAnalytics =
  (): UseDownloadCompleteModalAnalytics => {
    const { sendAnalytics, sendAnalyticsBefore } = useSendAnalytics({
      eventcategory: 'self-service management tool_orderhistory',
    });

    useEffect(() => {
      sendAnalytics({ eventaction: 'complete receipts download_impression' });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
      sendAnalyticsBefore,
    };
  };
